export default "__VITE_ASSET__DOVUFO$A__"